import { SpecificationConfigurationItem, SpecificationsLibrary } from '@grandvisionhq/fun-products'

export const commonSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.lensColor,
  SpecificationsLibrary.frameColor,
  SpecificationsLibrary.frameMaterial,
  SpecificationsLibrary.frameShape,
  SpecificationsLibrary.frameType,
  SpecificationsLibrary.gender,
  SpecificationsLibrary.roadworthiness,
  SpecificationsLibrary.opcoBackendId,
  SpecificationsLibrary.erpID,
  SpecificationsLibrary.faceShape,
  SpecificationsLibrary.templeColor,
  SpecificationsLibrary.sku,
]

export const clSpecifications: SpecificationConfigurationItem[] = [
  SpecificationsLibrary.materialType,
  SpecificationsLibrary.lensType,
  SpecificationsLibrary.clMaterial,
  SpecificationsLibrary.waterContent,
  SpecificationsLibrary.packageQuantity,
  SpecificationsLibrary.opcoBackendId,
  SpecificationsLibrary.erpID,
]
